import { cn } from '@/lib/utils';

interface Props {
    className?: string;
}

export const ProductIcon: React.FC<Props> = ({ className = '' }) => {
    return (
        <svg
            className={cn('stroke-neutral-400', className)}
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            fill="none"
            viewBox="0 0 11 11"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.434 3.224L5.337 5.5m0 0L1.241 3.224M5.337 5.5v4.578m4.338-2.622V3.544c0-.165 0-.248-.024-.321a.482.482 0 00-.104-.176c-.052-.057-.124-.097-.269-.177L5.712.889c-.137-.076-.205-.114-.277-.13a.482.482 0 00-.195 0c-.072.016-.14.054-.277.13L1.397 2.87c-.145.08-.217.12-.27.177a.482.482 0 00-.103.176C1 3.296 1 3.379 1 3.544v3.912c0 .165 0 .248.024.321a.482.482 0 00.104.176c.052.057.124.097.269.177l3.566 1.981c.137.076.205.114.277.13.064.012.13.012.195 0 .072-.016.14-.054.277-.13L9.278 8.13c.145-.08.217-.12.27-.177a.482.482 0 00.103-.176c.024-.073.024-.156.024-.321z"
            ></path>
        </svg>
    );
};
